import React, { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";

// Formik
import { useFormi, useFormik } from "formik";

// Material UI Components
import { Alert, AlertTitle } from "@material-ui/lab";
import Button from "@material-ui/core/Button";
import FormControl from "@material-ui/core/FormControl";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormLabel from "@material-ui/core/FormLabel";
import Grid from "@material-ui/core/Grid";
import InputLabel from "@material-ui/core/InputLabel";
import { makeStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import Select from "@material-ui/core/Select";
import Switch from "@material-ui/core/Switch";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import { SDCloudBackendAPIWithToken } from "apis/backendAPI";
// Local
import ProfileTable from "./ProfileTable";
import LoaderHoc from "components/HOC/LoaderHoc";

const inputProps = {
  disableAnimation: true,
  shrink: false
};

const formControlProps = {
  root: {
    marginTop: "10px"
  }
};

const useStyles = makeStyles((theme) => ({
  gridContainer: {
    padding: "0 40px",
  },
  radioButton: {
    "& .MuiTypography-root": {
      marginLeft: "10px",
    },
  },
  formControl: {
    width: "100%",
    marginTop: "5px",
  },
  warningNote: {
    "& .MuiAlert-icon": {
      display: "none",
    },
  },
  buttOutlined: {
    color: theme.palette.buttonColor.main,
    borderColor: theme.palette.buttonColor.main,
    "&:hover": {
      border: `1px solid ${theme.palette.buttonColor.main}`,
    },
  },
}));

const ProfileDetails = (props) => {
  const classes = useStyles();

  // States
  const [showNotification, setShowNotification] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState("");
  const [notificationType, setNotificationType] = useState("");
  const [learningsData, setLearningsData] = useState([]);
  const [showcasesData, setShowcasesData] = useState([]);
  const [sandboxesData, setSandboxesData] = useState([]);
  const [designerData, setDesignerData] = useState([]);
  const [maxTemplates, setMaxTemplates] = useState(props.maxTemplates);
  var initialLearnings = props.learningPerms;
  var initialSandboxes = props.sandboxPerms;

  const [designer, setDesigner] = useState([]);
  const [enabledLearnings, setEnabledLearnings] = useState(
    props.profile.learningPermissions
  );
  const [disabledLearnings, setDisabledLearnings] = useState([]);
  const [enabledSandboxes, setEnabledSandboxes] = useState(
    props.profile.sandboxPermissions
  );
  const [disabledSandboxes, setDisabledSandboxes] = useState([]);
  const [resourceData, setResourceData] = useState({});
  const [initialState, setInitialState] = useState({ ...props.profile });
  const [temp, setTemp] = useState(false);
  const [showLoader, setShowLoader] = useState(true);
  const [allocValue, setAllocValue] = useState(false);
  const [quotaErrors, setQuotaErrors] = useState({});
  const [hoursState, setHoursState] = useState({});
  const [dismissedAlerts, setDismissedAlerts] = useState({});

  useEffect(() => {
    setInitialState({ ...initialState, ...props.profile });
    setTemp(!temp);
    renderTemplateData(compare);
  }, [props.profile, props.profileData]);

  useEffect(() => {
    const activeErrors = Object.keys(quotaErrors);
    setDismissedAlerts((prev) => {
      const updated = { ...prev };
      activeErrors.forEach((key) => {
        // If there's a new error, reset dismissed state
        if (quotaErrors[key] && prev[key]) {
          updated[key] = false;
        }
      });
      return updated;
    });
  }, [quotaErrors]);

  const columns = [
    {
      Header: "Template Name",
      accessor: "template_name",
      // maxWidth: 360,
      // minWidth: 360,
      // width: 360
    },
    {
      Header: "Name",
      accessor: "display_name",
      // maxWidth: 360,
      // minWidth: 360,
      // width: 360
    },
    // {
    //   Header: "Can View",
    //   accessor: "can_view",
    // },
    {
      Header: "Permission",
      accessor: "permission",
    },
    // {
    //   Header: "Hours Available",
    //   accessor: "hours_available"
    // },
    {
      Header: "Lab Hours",
      accessor: "lab_hours",
    },
    {
      Header: "Allocated Hours",
      accessor: "allocate_hours",
    },
    {
      Header: "Consumed Hours",
      accessor: "hours_consumed",
    },
    {
      Header: "Max Templates",
      accessor: "max_allowed_templates",
    },
    {
      Header: "Allocated Quota",
      accessor: "allocated_quota",
    },
    {
      Header: "Available Quota",
      accessor: "available_quota",
    },
  ];

  const designerColumns = [
    {
      Header: "Template Name",
      accessor: "template_name",
    },
    {
      Header: "Name",
      accessor: "display_name",
    },
    {
      Header: "Permission",
      accessor: "permission",
    },
  ];

  const handleToggleChange = (value, type) => {
    if (type == "learn") {
      if (enabledLearnings.includes(value)) {
        let updatedLearnings = enabledLearnings.filter(function(
          name,
          index,
          arr
        ) {
          return name != value;
        });
        setEnabledLearnings([...updatedLearnings]);
        setQuotaErrors((prev) => {
          const newErrors = { ...prev };
          delete newErrors[value];
          return newErrors;
        });
        if (initialLearnings.includes(value)) {
          let deleteLearnings = disabledLearnings;
          deleteLearnings.push(value);
          setDisabledLearnings(deleteLearnings);
        }
      } else {
        let deleteLearnings = disabledLearnings.filter(function(
          name,
          index,
          arr
        ) {
          return name != value;
        });
        setDisabledLearnings(deleteLearnings);
        let updatedLearnings = enabledLearnings;
        updatedLearnings.push(value);
        setEnabledLearnings([...updatedLearnings]);
      }
    }
    if (type == "sandbox") {
      if (enabledSandboxes.includes(value)) {
        let updatedSandboxes = enabledSandboxes.filter(function(
          name,
          index,
          arr
        ) {
          return name != value;
        });
        setEnabledSandboxes([...updatedSandboxes]);
        setQuotaErrors((prev) => {
          const newErrors = { ...prev };
          delete newErrors[value];
          return newErrors;
        });
        if (initialSandboxes.includes(value)) {
          let deleteSandboxes = disabledSandboxes;
          deleteSandboxes.push(value);
          setDisabledSandboxes(deleteSandboxes);
        }
      } else {
        let deleteSandboxes = disabledSandboxes.filter(function(
          name,
          index,
          arr
        ) {
          return name != value;
        });
        setDisabledSandboxes(deleteSandboxes);
        let updatedSandboxes = enabledSandboxes;
        updatedSandboxes.push(value);
        setEnabledSandboxes([...updatedSandboxes]);
      }
    }
  };

  const formik = useFormik({
    initialValues: { ...initialState },
    enableReinitialize: true,
    onSubmit: (values) => {
      let permissions = [];
      let deletePermissions = [];
      let max_allowed_templates = 0;
      let quotaValidationErrors = {};
      // values.learningViews.forEach((item) => {
      //   let payload = {
      //     resource_type: "Learning",
      //     resource_name: item,
      //     permission: "view",
      //     alloc_hours: 0,
      //   };
      //   if (!values.learningPermissions.includes(item)) {
      //     permissions.push(payload);
      //   }
      // });
      enabledLearnings.forEach((item) => {
        try {
          const quotaValue = Number(
            document.getElementById(`${item}_quota`).value || 0
          );
          const permissionType = "create";
          if (permissionType === "create" && quotaValue <= 0) {
            quotaValidationErrors[
              item
            ] = `Quota is required and must be greater than 0 for ${item}`;
          }
          let payload = {
            resource_type: "Learning",
            resource_name: item,
            permission: permissionType,
            alloc_hours:
              document.getElementById(`${item}_allocate_hours`).value || 0,
            quota_value: document.getElementById(`${item}_quota`).value || 0,
          };
          permissions.push(payload);
        } catch (err) {
          //console.log("");
        }
      });
      disabledLearnings.forEach((item) => {
        try {
          let payload = {
            resource_type: "Learning",
            resource_name: item,
          };
          deletePermissions.push(payload);
        } catch (err) {
          //console.log("");
        }
      });

      // values.sandboxViews.forEach((item) => {
      //   let payload = {
      //     resource_type: "Sandbox",
      //     resource_name: item,
      //     permission: "view",
      //     alloc_hours: document.getElementById(`${item}_allocate_hours`).value,
      //   };
      //   if (!values.sandboxPermissions.includes(item)) {
      //     permissions.push(payload);
      //   }
      // });

      enabledSandboxes.forEach((item) => {
        try {
          const quotaValue = Number(
            document.getElementById(`${item}_quota`).value || 0
          );
          const permissionType = "create";
          if (permissionType === "create" && quotaValue <= 0) {
            quotaValidationErrors[
              item
            ] = `Quota is required and must be greater than 0 for ${item}`;
          }
          let payload = {
            resource_type: "Sandbox",
            resource_name: item,
            permission: permissionType,
            alloc_hours:
              document.getElementById(`${item}_allocate_hours`).value || 0,
            quota_value: document.getElementById(`${item}_quota`).value || 0,
          };

          if (item === "designer_portal") {
            payload["designer_objects"] = values.designerPermissions;
            max_allowed_templates =
              document.getElementById(`${item}_max_allowed_templates`).value ||
              0;
          }

          permissions.push(payload);
        } catch (err) {
          //console.log("");
        }
      });
      disabledSandboxes.forEach((item) => {
        try {
          let payload = {
            resource_type: "Sandbox",
            resource_name: item,
          };

          deletePermissions.push(payload);
        } catch (err) {
          //console.log("");
        }
      });
      if (Object.keys(quotaValidationErrors).length > 0) {
        setQuotaErrors(quotaValidationErrors);
        return;
      }
      let payload = {
        profile_name: props.profile.profile_name,
        permissions: permissions,
        delete_permissions: deletePermissions,
        delete: deletePermissions.length > 0 ? true : false,
        max_allowed_templates: max_allowed_templates,
      };

      SDCloudBackendAPIWithToken()
        .post("/update_profile", payload)
        .then((resp) => resp.data)
        .then((data) => {
          setShowNotification(true);
          setNotificationType("success");
          setNotificationMessage("Profile updated successfully");
          initialLearnings = props.learningPerms;
          initialSandboxes = props.sandboxPerms;
          setHoursState({});
          setTimeout(function() {
            window.location.reload();
          }, 2000);
        })
        .catch((err) => {
          let supportInfo = (
            <p>
              {err.response.data.message}. Visit our{" "}
              <a href="https://criterion.zendesk.com/hc/en-us" target="_blank">
                help center
              </a>{" "}
              for resources and support.
            </p>
          );
          // let message = err.response.data.message;
          setShowNotification(true);
          setNotificationType("error");
          setNotificationMessage(supportInfo);
        });
    },
  });

  const compare = (e, consumed_hours_value) => {
    if (Number(e.target.value) <= 0) {
      setAllocValue(true);
      setNotificationType("error");
      setNotificationMessage("Allocated hours should be greater than 0");
    } else if (Number(e.target.value) < Number(consumed_hours_value)) {
      setAllocValue(true);
      setNotificationType("error");
      setNotificationMessage(
        "Allocated hours should be greater than Consumed hours"
      );
    } else {
      setAllocValue(false);
    }
  };
  const renderTemplateData = async (compare) => {
    let data = {};

    if (Object.keys(resourceData).length === 0) {
      const response = await SDCloudBackendAPIWithToken().get("/get_resources");
      data = response.data;
      setResourceData(data);
    } else {
      data = resourceData;
    }

    let learnings = [];
    let showcases = [];
    let sandboxes = [];
    let designer = [];
    let designerObjects = [];

    // Learnings & Showcases
    data.learnings.forEach((item) => {
      let allocated_hours_value = null;
      let consumed_hours_value = 0;
      let quota_value = null;
      let allocated_quota_value = 0;
      let available_hours = 0;
      const enabled_learnings_list = props.profileData
        ? props.profileData.permissions.filter(p =>(p.resource_type === "learning" && p.permission === "create")).map((a) => a.resource_name)
        : [];
      if (props.profileData) {
        props.profileData.permissions.find((a) => {
          if (a.resource_name === item.name) {
            allocated_hours_value = a.allocated_hours;
            consumed_hours_value = parseFloat(a.consumed_hours).toFixed(2);
            quota_value = a.available_quota ? parseFloat(a.available_quota).toFixed(2) : 0 ;
            allocated_quota_value = Math.round(a.allocated_quota);
            available_hours = parseFloat(a.available_hours).toFixed(2);
          }
        });
      }
      if (item.is_scripted_demo) {
        showcases.push({
          template_name: item.name,
          display_name: item.display_name,
          can_view: (
            <FormControlLabel
              control={
                <Switch
                  value={item.name}
                  name="learningViews"
                  color="default"
                />
              }
              onChange={formik.handleChange}
              // onChange={e => {
              //   handleToggleChange(e.target.value);
              // }}
              checked={
                formik.values.learningViews.includes(item.name) ? true : false
              }
            />
          ),
          permission: (
            <FormControlLabel
              control={
                <Switch
                  value={item.name}
                  name="learningPermissions"
                  color="default"
                />
              }
              // onChange={formik.handleChange}
              onChange={(e) => {
                handleToggleChange(e.target.value, "learn");
              }}
              checked={enabledLearnings.includes(item.name) ? true : false}
            />
          ),
          // hours_available:
          //   item.allocated_hours - item.consumed_hours > 0
          //     ? item.allocated_hours - item.consumed_hours
          //     : 0,
          hours_consumed: consumed_hours_value,
          lab_hours: item.labhours,
          allocate_hours: (
            <TextField
              type="number"
              variant="filled"
              name={`${item.name}_allocate_hours`}
              fullWidth
              style={{ paddingRight: "15px" }}
              onChange={(e) => {
                const value = e.target.value;
                const newErrors = { ...quotaErrors };
                let error = "";
                if (value && value.includes(".")) {
                  error = `Decimal values are not allowed for ${item.display_name}. Please enter a whole number.`;
                }
                const newAllocatedHours = value === "" ? "" : Number(value);
                const allocated = Math.max(0, Number(newAllocatedHours) || 0);
                const consumed = Math.max(0, Number(consumed_hours_value) || 0);
                const quota = Math.max(0, Number(quota_value) || 0);

                let currentAvailable =
                  Math.max(0,allocated - consumed - quota);
                setHoursState((prev) => ({
                  ...prev,
                  [item.name]: {
                    ...prev[item.name],
                    allocated_hours: newAllocatedHours,
                  },
                }));
                const currentQuota =
                  hoursState[item.name]?.quota ?? quota_value ?? "";
                let additional_quota = Math.max(0,currentQuota - allocated_quota_value);

                if (newAllocatedHours < allocated_hours_value) {
                  error = `Allocated hours for ${item.display_name} cannot be less than the existing value of ${allocated_hours_value}.`;
                } else if (currentQuota > newAllocatedHours) {
                  error = `Additional Quota for ${item.display_name} cannot exceed allocated hours ${newAllocatedHours}.`;
                } else if (additional_quota > Number(currentAvailable)) {
                      error = `Additional Quota for ${item.display_name} cannot exceed available hours ${currentAvailable}.`;
                } else {
                  error = "";
                }
                if (error) {
                  newErrors[item.name] = error;
                } else {
                  delete newErrors[item.name];
                }
                setQuotaErrors(newErrors);
                compare(e, consumed_hours_value);
              }}
              inputProps={{ id: `${item.name}_allocate_hours` }}
              InputLabelProps={inputProps}
              value={
                hoursState[item.name]?.allocated_hours !== undefined
                  ? hoursState[item.name].allocated_hours
                  : (allocated_hours_value ?? item.allocated_hours ?? "")

              }
              disabled={!enabled_learnings_list.includes(item.name) || Number(available_hours) > item.labhours}
            />
          ),
          available_quota: quota_value || 0,
          allocated_quota: (
            <TextField
              type="number"
              variant="filled"
              name={`${item.name}_quota`}
              fullWidth
              style={{ paddingRight: "15px" }}
              onChange={(e) => {
                const value = e.target.value;
                const newErrors = { ...quotaErrors };
                let error = "";
                if (value &&value.includes(".")) {
                  error = `Decimal values are not allowed for ${item.display_name}. Please enter a whole number.`;
                }
                const newQuota = value === "" ? "" : Number(value);
                setHoursState((prev) => ({
                  ...prev,
                  [item.name]: {
                    ...prev[item.name],
                    quota: newQuota,
                  },
                }));
                const currentAllocated =
                  hoursState[item.name]?.allocated_hours ??
                  allocated_hours_value ??
                  item.allocated_hours ??
                  0;
                const allocated = Math.max(0, Number(currentAllocated) || 0);
                const consumed = Math.max(0, Number(consumed_hours_value) || 0);
                const quota = Math.max(0, Number(quota_value) || 0);

                let currentAvailable =
                  Math.max(0,allocated - consumed - quota);
                let additional_quota = Math.max(0,newQuota - allocated_quota_value);
                const min = item.labhours;
                const max = 3 * item.labhours;

                if (newQuota) {
                  if (newQuota > Number(currentAllocated)) {
                    error = `Allocated Quota for ${item.display_name} cannot exceed allocated hours ${currentAllocated}.`;
                  } else if (
                    enabled_learnings_list.includes(item.name) &&
                    newQuota <= (max + allocated_quota_value)
                  ) {
                    if (Number(currentAvailable) <= 0) {
                      error = `No available hours for ${item.display_name}. Please add allocated hours before assigning a quota.`;
                    } else if (additional_quota > Number(currentAvailable)) {
                      error = `Additional Quota for ${item.display_name} cannot exceed available hours ${currentAvailable}.`;
                    } else if (newQuota < allocated_quota_value) {
                      error = `Additional Quota for ${item.display_name} cannot be less than the existing value of ${allocated_quota_value}`;
                    } else if (newQuota < (min + allocated_quota_value)) {
                      error = `Additional quota for ${item.display_name} should be atleast equal to lab hours for Learnings and Showcases.`
                    }
                  } else if (allocated_quota_value === 0){
                    if(newQuota < min){
                      error = `Allocated Quota for ${item.display_name} should be at least equal to lab hours for Learnings and Showcases.`;
                    } else if(newQuota > max){
                      error = `Allocated Quota for ${item.display_name} cannot exceed 3 times of lab hours for Learnings and Showcases.`;
                    }
                  } else if (newQuota > (max + allocated_quota_value)) {
                    error = `Additional quota for ${item.display_name} cannot be more than 3 times the lab hours for Learnings and Showcases.`;
                  }
                }
                if (error) {
                  newErrors[item.name] = error;
                } else {
                  delete newErrors[item.name];
                }
                setQuotaErrors(newErrors);
              }}
              InputProps={{ id: `${item.name}_quota` }}
              InputLabelProps={inputProps}
              value={hoursState[item.name]?.quota ?? allocated_quota_value ?? ""}
            />
          ),
        });
      } else {
        learnings.push({
          template_name: item.name,
          display_name: item.display_name,
          can_view: (
            <FormControlLabel
              control={
                <Switch
                  value={item.name}
                  name="learningViews"
                  color="default"
                />
              }
              onChange={formik.handleChange}
              checked={
                formik.values.learningViews.includes(item.name) ? true : false
              }
            />
          ),
          permission: (
            <FormControlLabel
              control={
                <Switch
                  value={item.name}
                  name="learningPermissions"
                  color="default"
                />
              }
              // onChange={formik.handleChange}
              onChange={(e) => {
                handleToggleChange(e.target.value, "learn");
              }}
              checked={enabledLearnings.includes(item.name) ? true : false}
            />
          ),
          // hours_available:
          //   item.allocated_hours - item.consumed_hours > 0
          //     ? item.allocated_hours - item.consumed_hours
          //     : 0,
          hours_consumed: consumed_hours_value,
          lab_hours: item.labhours,
          allocate_hours: (
            <TextField
              type="number"
              variant="filled"
              name={`${item.name}_allocate_hours`}
              fullWidth
              style={{ paddingRight: "15px" }}
              onChange={(e) => {
                const value = e.target.value;
                const newErrors = { ...quotaErrors };
                let error = "";
                if (value &&value.includes(".")) {
                  error = `Decimal values are not allowed for ${item.display_name}. Please enter a whole number.`;
                }
                const newAllocatedHours = value === "" ? "" : Number(value);
                const allocated = Math.max(0, Number(newAllocatedHours) || 0);
                const consumed = Math.max(0, Number(consumed_hours_value) || 0);
                const quota = Math.max(0, Number(quota_value) || 0);

                let currentAvailable =
                  Math.max(0,allocated - consumed - quota);
                setHoursState((prev) => ({
                  ...prev,
                  [item.name]: {
                    ...prev[item.name],
                    allocated_hours: newAllocatedHours,
                  },
                }));
                const currentQuota =
                  hoursState[item.name]?.quota ?? quota_value ?? "";
                let additional_quota = Math.max(0,currentQuota - allocated_quota_value);

                if (newAllocatedHours < allocated_hours_value) {
                  error = `Allocated hours for ${item.display_name} cannot be less than the existing value of ${allocated_hours_value}.`;
                } else if (currentQuota > newAllocatedHours) {
                  error = `Additional Quota for ${item.display_name} cannot exceed allocated hours ${newAllocatedHours}.`;
                } else if (additional_quota > Number(currentAvailable)) {
                      error = `Additional Quota for ${item.display_name} cannot exceed available hours ${currentAvailable}.`;
                } else {
                  error = "";
                }
                if (error) {
                  newErrors[item.name] = error;
                } else {
                  delete newErrors[item.name];
                }
                setQuotaErrors(newErrors);
                compare(e, consumed_hours_value);
              }}
              inputProps={{ id: `${item.name}_allocate_hours` }}
              InputLabelProps={inputProps}
              value={
                hoursState[item.name]?.allocated_hours !== undefined
                  ? hoursState[item.name].allocated_hours
                  : (allocated_hours_value ?? item.allocated_hours ?? "")
              }
              disabled={!enabled_learnings_list.includes(item.name) || Number(available_hours) > item.labhours}
            />
          ),
          available_quota: quota_value || 0,
          allocated_quota: (
            <TextField
              type="number"
              variant="filled"
              name={`${item.name}_quota`}
              fullWidth
              style={{ paddingRight: "15px" }}
              onChange={(e) => {
                const value = e.target.value;
                const newErrors = { ...quotaErrors };
                let error = "";
                if (value &&value.includes(".")) {
                  error = `Decimal values are not allowed for ${item.display_name}. Please enter a whole number.`;
                }
                const newQuota = value === "" ? "" : Number(value);
                setHoursState((prev) => ({
                  ...prev,
                  [item.name]: {
                    ...prev[item.name],
                    quota: newQuota,
                  },
                }));
                const currentAllocated =
                  hoursState[item.name]?.allocated_hours ??
                  allocated_hours_value ??
                  item.allocated_hours ??
                  0;
                const allocated = Math.max(0, Number(currentAllocated) || 0);
                const consumed = Math.max(0, Number(consumed_hours_value) || 0);
                const quota = Math.max(0, Number(quota_value) || 0);

                let currentAvailable =
                  Math.max(0,allocated - consumed - quota);
                let additional_quota = Math.max(0,newQuota - allocated_quota_value);
                const min = item.labhours;
                const max = 3 * item.labhours;

                if (newQuota) {
                  if (newQuota > Number(currentAllocated)) {
                    error = `Allocated Quota for ${item.display_name} cannot exceed allocated hours ${currentAllocated}.`;
                  } else if (
                    enabled_learnings_list.includes(item.name) &&
                    newQuota <= (max + allocated_quota_value)
                  ) {
                    if (Number(currentAvailable) <= 0) {
                      error = `No available hours for ${item.display_name}. Please add allocated hours before assigning a quota.`;
                    } else if (additional_quota > Number(currentAvailable)) {
                      error = `Additional Quota for ${item.display_name} cannot exceed available hours ${currentAvailable}.`;
                    } else if (newQuota < allocated_quota_value) {
                      error = `Additional Quota for ${item.display_name} cannot be less than the existing value of ${allocated_quota_value}`;
                    } else if (newQuota < (min + allocated_quota_value)) {
                      error = `Additional quota for ${item.display_name} should be atleast equal to lab hours for Learnings and Showcases.`;
                    }
                  } else if (allocated_quota_value === 0){
                    if(newQuota < min){
                      error = `Allocated Quota for ${item.display_name} should be atleast equal to lab hours for Learnings and Showcases.`;
                    } else if(newQuota > max){
                      error = `Allocated Quota for ${item.display_name} cannot exceed 3 times of lab hours for Learnings and Showcases.`;
                    }
                  } else if (newQuota > (max + allocated_quota_value)) {
                    error = `Additional quota for ${item.display_name} cannot be more than 3 times the lab hours for Learnings and Showcases.`;
                  } 
                }
                if (error) {
                  newErrors[item.name] = error;
                } else {
                  delete newErrors[item.name];
                }
                setQuotaErrors(newErrors);
              }}
              InputProps={{ id: `${item.name}_quota` }}
              InputLabelProps={inputProps}
              value={hoursState[item.name]?.quota ?? allocated_quota_value ?? ""}
            />
          ),
        });
      }
    });

    // Sandboxes & Designer
    data.sandboxes.forEach((item) => {
      let allocated_hours_value = null;
      let consumed_hours_value = 0;
      let quota_value = null;
      let available_hours = 0;
      let allocated_quota_value = 0;
      item.display_name = item.display_name?.trim()
        ? item.display_name
        : item.name;
      const enabled_sandboxes_list = props.profileData
        ? props.profileData.permissions.filter(p =>(p.resource_type === "sandbox" && p.permission === "create")).map((a) => a.resource_name)
        : [];
      if (props.profileData) {
        props.profileData.permissions.find((a) => {
          if (a.resource_name === item.name) {
            allocated_hours_value = a.allocated_hours;
            consumed_hours_value = parseFloat(a.consumed_hours).toFixed(2);
            quota_value = parseFloat(a.available_quota).toFixed(2);
            allocated_quota_value = Math.round(a.allocated_quota);
            available_hours = parseFloat(a.available_hours).toFixed(2);
          }
        });
      }
      if (item.name === "designer_portal") {
        designerObjects = item.designer_objects.map((designerObject) => ({
          template_name: designerObject.name,
          display_name: designerObject.display_name,
          permission: (
            <FormControlLabel
              control={
                <Switch
                  value={designerObject.name}
                  name={`designerPermissions`}
                  color="default"
                />
              }
              onChange={formik.handleChange}
            />
          ),
        }));

        designer.push({
          template_name: item.name,
          display_name: "Designer",
          can_view: (
            <FormControlLabel
              control={
                <Switch
                  value={item.name}
                  name={`sandboxViews`}
                  color="default"
                />
              }
              onChange={formik.handleChange}
              checked={
                formik.values.sandboxViews.includes(item.name) ? true : false
              }
            />
          ),
          permission: (
            <FormControlLabel
              control={
                <Switch
                  value={item.name}
                  name={`sandboxPermissions`}
                  color="default"
                />
              }
              // onChange={formik.handleChange}
              onChange={(e) => {
                handleToggleChange(e.target.value, "sandbox");
              }}
              checked={enabledSandboxes.includes(item.name) ? true : false}
            />
          ),
          // hours_available:
          //   item.allocated_hours - item.consumed_hours > 0
          //     ? item.allocated_hours - item.consumed_hours
          //     : 0,
          hours_consumed: consumed_hours_value,
          lab_hours: item.labhours,
          allocate_hours: (
            <TextField
              type="number"
              variant="filled"
              name={`${item.name}_allocate_hours`}
              fullWidth
              InputProps={{ id: `${item.name}_allocate_hours` }}
              InputLabelProps={inputProps}
              value={
                hoursState[item.name]?.allocated_hours !== undefined
                  ? hoursState[item.name].allocated_hours
                  : (allocated_hours_value ?? item.allocated_hours ?? "")
              }
              style={{ paddingRight: "15px" }}
              onChange={(e) => {
                const value = e.target.value;
                const newErrors = { ...quotaErrors };
                let error = "";
                if (value &&value.includes(".")) {
                  error = `Decimal values are not allowed for ${item.display_name}. Please enter a whole number.`;
                }
                const newAllocatedHours = value === "" ? "" : Number(value);
                const allocated = Math.max(0, Number(newAllocatedHours) || 0);
                const consumed = Math.max(0, Number(consumed_hours_value) || 0);
                const quota = Math.max(0, Number(quota_value) || 0);

                let currentAvailable =
                  Math.max(0,allocated - consumed - quota);
                setHoursState((prev) => ({
                  ...prev,
                  [item.name]: {
                    ...prev[item.name],
                    allocated_hours: newAllocatedHours,
                  },
                }));
                const currentQuota =
                  hoursState[item.name]?.quota ?? quota_value ?? "";
                let additional_quota = Math.max(0,currentQuota - allocated_quota_value);
                if (newAllocatedHours < allocated_hours_value) {
                  error = `Allocated hours for ${item.display_name} cannot be less than the existing value of ${allocated_hours_value}.`;
                } else if (currentQuota > newAllocatedHours) {
                  error = `Additional Quota for ${item.display_name} cannot exceed allocated hours ${newAllocatedHours}.`;
                } else if (additional_quota > Number(currentAvailable)) {
                  error = `Additional Quota for ${item.display_name} cannot exceed available hours ${currentAvailable}.`;
                } else {
                  error = "";
                }
                if (error) {
                  newErrors[item.name] = error;
                } else {
                  delete newErrors[item.name];
                }
                setQuotaErrors(newErrors);
                compare(e, consumed_hours_value);
              }}
              disabled={
                !enabled_sandboxes_list.includes(item.name) ||
                Number(available_hours) > 10
              }
            />
          ),
          max_allowed_templates: (
            <TextField
              type="number"
              variant="filled"
              name={`${item.name}_max_allowed_templates`}
              fullWidth
              InputProps={{ id: `${item.name}_max_allowed_templates` }}
              InputLabelProps={inputProps}
              defaultValue={maxTemplates}
              style={{ paddingRight: "15px" }}
            />
          ),
          available_quota: quota_value || 0,
          allocated_quota: (
            <TextField
              type="number"
              variant="filled"
              name={`${item.name}_quota`}
              fullWidth
              style={{ paddingRight: "15px" }}
              onChange={(e) => {
                const value = e.target.value;
                const newErrors = { ...quotaErrors };
                let error = "";
                if (value &&value.includes(".")) {
                  error = `Decimal values are not allowed for ${item.display_name}. Please enter a whole number.`;
                }
                const newQuota = value === "" ? "" : Number(value);
                setHoursState((prev) => ({
                  ...prev,
                  [item.name]: {
                    ...prev[item.name],
                    quota: newQuota,
                  },
                }));
                const currentAllocated =
                  hoursState[item.name]?.allocated_hours ??
                  allocated_hours_value ??
                  item.allocated_hours ??
                  0;
                const allocated = Math.max(0, Number(currentAllocated) || 0);
                const consumed = Math.max(0, Number(consumed_hours_value) || 0);
                const quota = Math.max(0, Number(quota_value) || 0);

                let currentAvailable =
                  Math.max(0,allocated - consumed - quota);
                let additional_quota = Math.max(0,newQuota - allocated_quota_value);

                if (newQuota) {
                  if (newQuota > Number(currentAllocated)) {
                    error = `Allocated Quota for ${item.display_name} cannot exceed allocated hours ${currentAllocated}.`;
                  } else if (
                    enabled_sandboxes_list.includes(item.name) &&
                    newQuota <= (allocated_quota_value+20)
                  ) {
                    if (Number(currentAvailable) <= 0) {
                      error = `No available hours for ${item.display_name}. Please add allocated hours before assigning a quota.`;
                    } else if (additional_quota > Number(currentAvailable)) {
                      error = `Additional Quota for ${item.display_name} cannot exceed available hours ${currentAvailable}.`;
                    } else if (newQuota < allocated_quota_value) {
                      error = `Additional Quota for ${item.display_name} cannot be less than the existing value of ${allocated_quota_value}`;
                    }
                  } else if (allocated_quota_value === 0 && newQuota > 20){
                    error = `Allocate Quota for ${item.display_name} cannot exceed 20 for Sandboxes and Design Center.`;
                  } else if (newQuota > (allocated_quota_value+20)) {
                    error = `Additional Quota for ${item.display_name} cannot be more than 20 for Sandboxes and Design Center.`;
                  } else if (newQuota <= 0) {
                    error = `Allocate Quota for ${item.display_name} cannot be less than 0 for Sandboxes and Design Center`;
                  }
                }
                if (error) {
                  newErrors[item.name] = error;
                } else {
                  delete newErrors[item.name];
                }
                setQuotaErrors(newErrors);
              }}
              InputProps={{ id: `${item.name}_quota` }}
              InputLabelProps={inputProps}
              value={hoursState[item.name]?.quota ?? allocated_quota_value ?? ""}
            />
          ),
        });

        setDesigner(designerObjects);
      } else {
        sandboxes.push({
          template_name: item.name,
          display_name:
            item.name === "designer_portal" ? "Designer" : item.display_name,
          can_view: (
            <FormControlLabel
              control={
                <Switch
                  value={item.name}
                  name={`sandboxViews`}
                  color="default"
                />
              }
              onChange={formik.handleChange}
              checked={
                formik.values.sandboxViews.includes(item.name) ? true : false
              }
            />
          ),
          permission: (
            <FormControlLabel
              control={
                <Switch
                  value={item.name}
                  name={`sandboxPermissions`}
                  color="default"
                />
              }
              // onChange={formik.handleChange}
              onChange={(e) => {
                handleToggleChange(e.target.value, "sandbox");
              }}
              checked={enabledSandboxes.includes(item.name) ? true : false}
            />
          ),
          // hours_available:
          //   item.allocated_hours - item.consumed_hours > 0
          //     ? item.allocated_hours - item.consumed_hours
          //     : 0,
          hours_consumed: consumed_hours_value,
          lab_hours: item.labhours,
          allocate_hours: (
            <TextField
              type="number"
              variant="filled"
              name={`${item.name}_allocate_hours`}
              fullWidth
              style={{ paddingRight: "15px" }}
              onChange={(e) => {
                const value = e.target.value;
                const newErrors = { ...quotaErrors };
                let error = "";
                if (value &&value.includes(".")) {
                  error = `Decimal values are not allowed for ${item.display_name}. Please enter a whole number.`;
                }
                const newAllocatedHours = value === "" ? "" : Number(value);
                setHoursState((prev) => ({
                  ...prev,
                  [item.name]: {
                    ...prev[item.name],
                    allocated_hours: newAllocatedHours,
                  },
                }));
                const allocated = Math.max(0, Number(newAllocatedHours) || 0);
                const consumed = Math.max(0, Number(consumed_hours_value) || 0);
                const quota = Math.max(0, Number(quota_value) || 0);

                let currentAvailable =
                   Math.max(0,allocated - consumed - quota);
                const currentQuota =
                  hoursState[item.name]?.quota ?? quota_value ?? "";
                let additional_quota = Math.max(0,currentQuota - allocated_quota_value);
          
                if (newAllocatedHours < allocated_hours_value) {
                  error = `Allocated hours for ${item.display_name} cannot be less than the existing value of ${allocated_hours_value}.`;
                } else if (currentQuota > newAllocatedHours) {
                  error = `Additional Quota for ${item.display_name} cannot exceed allocated hours ${newAllocatedHours}.`;
                } else if (additional_quota > Number(currentAvailable)) {
                  error = `Additional Quota for ${item.display_name} cannot exceed available hours ${currentAvailable}.`;
                } else {
                  error = "";
                }
                if (error) {
                  newErrors[item.name] = error;
                } else {
                  delete newErrors[item.name];
                }
                setQuotaErrors(newErrors);
                compare(e, consumed_hours_value);
              }}
              InputProps={{ id: `${item.name}_allocate_hours` }}
              InputLabelProps={inputProps}
              value={
                hoursState[item.name]?.allocated_hours !== undefined
                  ? hoursState[item.name].allocated_hours
                  : (allocated_hours_value ?? item.allocated_hours ?? "")
              }
              disabled={!enabled_sandboxes_list.includes(item.name) || Number(available_hours) > 10}
            />
          ),
          available_quota: quota_value || 0,
          allocated_quota: (
            <TextField
              type="number"
              variant="filled"
              name={`${item.name}_quota`}
              fullWidth
              style={{ paddingRight: "15px" }}
              onChange={(e) => {
                const value = e.target.value;
                const newErrors = { ...quotaErrors };
                let error = "";
                if (value &&value.includes(".")) {
                  error = `Decimal values are not allowed for ${item.display_name}. Please enter a whole number.`;
                }
                const newQuota = value === "" ? "" : Number(value);
                setHoursState((prev) => ({
                  ...prev,
                  [item.name]: {
                    ...prev[item.name],
                    quota: newQuota,
                  },
                }));
                const currentAllocated =
                  hoursState[item.name]?.allocated_hours ??
                  allocated_hours_value ??
                  item.allocated_hours ??
                  0;
                const allocated = Math.max(0, Number(currentAllocated) || 0);
                const consumed = Math.max(0, Number(consumed_hours_value) || 0);
                const quota = Math.max(0, Number(quota_value) || 0);

                let currentAvailable =
                   Math.max(0,allocated - consumed - quota);
                let additional_quota = Math.max(0,newQuota - allocated_quota_value);
                if (newQuota) {
                  if (newQuota > Number(currentAllocated)) {
                    error = `Allocated Quota for ${item.display_name} cannot exceed allocated hours ${currentAllocated}.`;
                  } else if (
                    enabled_sandboxes_list.includes(item.name) &&
                    newQuota <= (allocated_quota_value+20)
                  ) {
                    if (Number(currentAvailable) <= 0) {
                      error = `No available hours for ${item.display_name}. Please add allocated hours before assigning a quota.`;
                    } else if (additional_quota > Number(currentAvailable)) {
                      error = `Additional Quota for ${item.display_name} cannot exceed available hours ${currentAvailable}.`;
                    } else if (newQuota < allocated_quota_value) {
                      error = `Additional Quota for ${item.display_name} cannot be less than the existing value of ${allocated_quota_value}`;
                    }
                  } else if (allocated_quota_value === 0 && newQuota > 20){
                    error = `Allocate Quota for ${item.display_name} cannot exceed 20 for Sandboxes and Design Center.`;
                  } else if (newQuota > (allocated_quota_value+20)) {
                    error = `Additional Quota for ${item.display_name} cannot be more than 20 for Sandboxes and Design Center.`;
                  } else if (newQuota <= 0) {
                    error = `Allocate Quota for ${item.display_name} cannot be less than 0 for Sandboxes and Design Center`;
                  }
                }
                if (error) {
                  newErrors[item.name] = error;
                } else {
                  delete newErrors[item.name];
                }
                setQuotaErrors(newErrors);
              }}
              InputProps={{ id: `${item.name}_quota` }}
              InputLabelProps={inputProps}
              value={hoursState[item.name]?.quota ?? allocated_quota_value ?? ""}
            />
          ),
        });
      }
    });

    setLearningsData(learnings);
    setShowcasesData(showcases);
    setSandboxesData(sandboxes);
    setDesignerData(designer);
    setShowLoader(false);
  };

  useEffect(() => {
    renderTemplateData(compare);
  }, [
    formik.values,
    enabledLearnings,
    enabledSandboxes,
    disabledLearnings,
    disabledSandboxes,
    allocValue,
    hoursState,
  ]);

  return (
    <div>
      <form onSubmit={formik.handleSubmit}>
        <Grid container className={classes.gridContainer}>
          <Grid item md={12}>
            <Typography variant="h4">{props.profile.profile_name}</Typography>
          </Grid>

          {showLoader ? (
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                marginTop: "80px",
              }}
            >
              <LoaderHoc isLoading={showLoader}></LoaderHoc>
            </div>
          ) : (
            <>
              <Grid item xs={12} md={12} style={{ marginTop: "35px" }}>
                <Grid container justify="space-between">
                  <ProfileTable
                    columns={columns}
                    data={learningsData}
                    tableTitle="Learning Center"
                    buttonTitle="Create Profile"
                    dropDownValues={[]}
                    hiddenColumns={[
                      "template_name",
                      // "hours_available",
                      "max_allowed_templates",
                    ]}
                  />
                </Grid>
              </Grid>
              <Grid item xs={12} md={12} style={{ marginTop: "35px" }}>
                <Grid container justify="space-between">
                  <ProfileTable
                    columns={columns}
                    data={showcasesData}
                    tableTitle="Experience Center - Showcases"
                    buttonTitle="Create Profile"
                    dropDownValues={[]}
                    hiddenColumns={[
                      "template_name",
                      // "hours_available",
                      "max_allowed_templates",
                    ]}
                  />
                </Grid>
              </Grid>
              <Grid item xs={12} md={12} style={{ marginTop: "35px" }}>
                <Grid container justify="space-between">
                  <ProfileTable
                    columns={columns}
                    data={sandboxesData}
                    tableTitle="Experience Center - Sandboxes"
                    buttonTitle="Create Profile"
                    dropDownValues={[]}
                    hiddenColumns={[
                      "template_name",
                      "lab_hours",
                      // "hours_available",
                      "max_allowed_templates",
                    ]}
                  />
                </Grid>
              </Grid>
              <Grid item xs={12} md={12} style={{ marginTop: "35px" }}>
                <Grid container justify="space-between">
                  <ProfileTable
                    columns={columns}
                    data={designerData}
                    tableTitle="Design Center"
                    buttonTitle="Create Profile"
                    dropDownValues={[]}
                    hiddenColumns={[
                      "template_name",
                      "lab_hours",
                      // "hours_available"
                    ]}
                  />
                </Grid>
              </Grid>

              <Grid item xs={12} md={12}>
                {Object.entries(quotaErrors).map(([resource, message]) => {
                  if (!message || dismissedAlerts[resource]) return null; // hide if dismissed
                  return (
                    <Alert
                      key={resource}
                      severity="error"
                      onClose={() =>
                        setDismissedAlerts((prev) => ({
                          ...prev,
                          [resource]: true,
                        }))
                      }
                      sx={{ mb: 1 }}
                    >
                      {message}
                    </Alert>
                  );
                })}
              </Grid>

              <Grid item xs={12} md={12}>
                {allocValue ? (
                  <Alert
                    onClose={() => setShowNotification(false)}
                    severity={notificationType}
                  >
                    {notificationMessage}
                  </Alert>
                ) : null}
              </Grid>
              <Grid item xs={12} md={12}>
                {showNotification ? (
                  <Alert
                    onClose={() => setShowNotification(false)}
                    severity={notificationType}
                  >
                    {notificationMessage}
                  </Alert>
                ) : null}
              </Grid>
              <Grid item xs={12} md={2}>
                <Button
                  variant="outlined"
                  color="secondary"
                  disableElevation
                  size="large"
                  fullWidth
                  className={classes.buttOutlined}
                  disableFocusRipple
                  type="submit"
                  disabled={allocValue || Object.values(quotaErrors).some(Boolean)}
                >
                  Submit
                </Button>
              </Grid>
            </>
          )}
        </Grid>

        {/* </Grid> */}
      </form>
    </div>
  );
};

export default ProfileDetails;
